import React from 'react'
import ContactHero from './ContactHero'
import ContactUsForm from './ContactUsForm'

const ContactUs = () => {
  return (
    <div>
      <ContactHero></ContactHero>
      <ContactUsForm></ContactUsForm>
    </div>
  )
}

export default ContactUs
